import React, { useState } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useTheme } from '../../../../components/mui/Styles/index'
import { Box, Button, Card, CardContent, TextField } from '../../../../components/mui/Core/index'
import FormHeading from '../../../../components/userauthentication/FormHeading'
import GenericSnackbar from '../../../../components/GenericSnackbar/generic-snackbar'
import Constants from '../../../../constants/en.json'
import { verifyMfaToken } from '../../../../api/user/verify-mfa-token'
import { setSnackbar } from '../../../../components/GenericSnackbar/generic-snackbar-slice'

function EnableMFA() {
  const theme = useTheme()
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const userMfaData = location.state
  const [totpCode, setTotpCode] = useState('')
  const isSubmitTotpCodeDisabled = totpCode.length === 6

  const handleOnChangeTotpCode = (event) => {
    if (event.target.value !== '') {
      setTotpCode(event.target.value)
    }
  }

  const handleTotpCodeFieldOnKeyDown = (e) => {
    if (e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+') {
      e.preventDefault()
    }
  }

  const handleTotpCodeFieldOnInput = (e) => {
    e.target.value = e.target.value.toString().slice(0, 6)
  }

  const handleSubmitToptCode = async () => {
    const request = {
      requestBody: {
        sessionId: userMfaData?.sessionId,
        accessCode: totpCode,
      },
    }
    await verifyMfaToken(request)
      .then(() => {
        navigate('/-signup/success')
      })
      .catch((exception) => {
        dispatch(
          setSnackbar({
            message: exception?.message,
            severity: 'error',
            action: true,
          }),
        )
      })
  }

  const cardContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  }
  const enableMfaMessageContainer = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '36px',
    width: '448px',
    marginTop: '12px',
  }
  const mfaStepOneContainerStyle = { width: '430px', marginTop: '20px' }
  const mfaStepTwoContainerStyle = { width: '430px', marginTop: '20px' }
  const qrCodeContainerStyle = { marginTop: '20px' }
  const totpCodeTextFieldContainerStyle = { marginTop: '20px' }
  const totpCodeTextFieldStyle = {
    width: '412px',
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none',
    },
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
  }
  const submitTotpCodeContainerStyle = { marginTop: '40px' }

  return (
    <>
      <Box sx={theme.soloContainer}>
        <Card className='soloCard'>
          <CardContent sx={cardContentStyle}>
            <FormHeading formHeader={Constants.enableMfa.TITLE} />
            <Box sx={enableMfaMessageContainer}>
              <span>{Constants.enableMfa.ENABLE_MFA_MESSAGE_1}</span>
              <span>{Constants.enableMfa.ENABLE_MFA_MESSAGE_2}</span>
            </Box>
            <Box sx={mfaStepOneContainerStyle}> {Constants.enableMfa.ENABLE_MFA_STEP_1}</Box>
            <Box sx={qrCodeContainerStyle}>
              <QRCodeSVG size='152' value={userMfaData?.qrCodeUrl} />
            </Box>
            <Box sx={mfaStepTwoContainerStyle}> {Constants.enableMfa.ENABLE_MFA_STEP_2}</Box>
            <Box sx={totpCodeTextFieldContainerStyle}>
              <TextField
                sx={totpCodeTextFieldStyle}
                slotProps={{
                  input: { inputProps: { 'data-testid': 'enter-mfa-totp-code-input-field' } },
                }}
                label={Constants.enableMfa.AUTHENTICATION_CODE}
                variant='outlined'
                type='number'
                slot={{ input: { maxLength: 6 } }}
                onChange={handleOnChangeTotpCode}
                onInput={handleTotpCodeFieldOnInput}
                onKeyDown={handleTotpCodeFieldOnKeyDown}
              />
            </Box>
            <Box sx={submitTotpCodeContainerStyle}>
              <Button
                variant='contained'
                color='secondary'
                onClick={handleSubmitToptCode}
                disabled={!isSubmitTotpCodeDisabled}
              >
                {Constants.enableMfa.SUBMIT}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
      <GenericSnackbar />
    </>
  )
}

export default EnableMFA
